export const GET_TRACKED_ITEMS_SUCCESS = "GET_TRACKED_ITEMS_SUCCESS";
export const GET_SYSTEM_CREATED_TRACKED_ITEMS_SUCCESS = "GET_SYSTEM_CREATED_TRACKED_ITEMS_SUCCESS";
export const GET_USER_CREATED_TRACKED_ITEMS_SUCCESS = "GET_USER_CREATED_TRACKED_ITEMS_SUCCESS";
export const GET_HIDDEN_TRACKED_ITEMS_SUCCESS = "GET_HIDDEN_TRACKED_ITEMS_SUCCESS";
export const UPDATE_TRACKED_ITEM_SUCCESS = "UPDATE_TRACKED_ITEMUPDATE_SUCCESS";
export const ADD_TRACKED_ITEM_SUCCESS = "ADD_TRACKED_ITEM_SUCCESS";
export const INACTIVATE_TRACKED_ITEM_SUCCESS = "INACTIVATE_TRACKED_ITEM_SUCCESS";
export const ACTIVATE_TRACKED_ITEM_SUCCESS = "ACTIVATE_TRACKED_ITEM_SUCCESS";
export const EMPTY_TRACKED_ITEM_SUCCESS = "EMPTY_TRACKED_ITEM_SUCCESS";
